var _line, _circle, _line2, _circle2, _line3, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.1034,
    y1: 6.6727,
    x2: 7.73989,
    y2: 10.3723,
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 4,
    r: 3,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 18.8554,
    y1: 12.8894,
    x2: 16.5237,
    y2: 8.46632,
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.7216,
    cy: 15.5833,
    r: 3,
    transform: "rotate(109.928 20.7216 15.5833)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 8.25646,
    y1: 16.3117,
    x2: 13.2565,
    y2: 16.3077,
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.6303,
    cy: 16.4211,
    r: 3,
    transform: "rotate(-129.446 5.6303 16.4211)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStageIcon);
export default __webpack_public_path__ + "static/media/StageIcon.96d838f778dc7ca371aaa81ecbcce68a.svg";
export { ForwardRef as ReactComponent };